import { lazy, type ComponentType } from 'react'

type LazyComponentModule<Props extends object> = { default: ComponentType<Props> }

export function lazyRouteComponent<Props extends object>(
  componentName: string,
  loader: () => Promise<LazyComponentModule<Props>>,
): ComponentType<Props> {
  const LazyComponent = lazy(loader)
  const RouteComponent = (props: Props) => <LazyComponent {...props} />
  Object.defineProperty(RouteComponent, 'name', { value: componentName })
  return RouteComponent
}
